import { useTheme } from '@mui/material/styles';
import React from 'react';
import { MULTIPLE_VEHICLES_TEXT } from '../../../Constants/Constants';

interface ClaimDescriptionLinkProps {
  description: string;
  onMultipleVehiclesClick?: () => void;
  maskInDatadog?: boolean;
}

/**
 * Reusable component for rendering claim descriptions with clickable "Multiple Vehicles" links
 */
export default function ClaimDescriptionLink({
  description,
  onMultipleVehiclesClick,
  maskInDatadog = false,
}: ClaimDescriptionLinkProps) {
  const theme = useTheme();

  // Only render an interactive, styled link when a click handler is provided.
  // Without one, fall through to plain text so it doesn't look like a link.
  if (onMultipleVehiclesClick && description.includes(MULTIPLE_VEHICLES_TEXT)) {
    const matchIndex = description.indexOf(MULTIPLE_VEHICLES_TEXT);
    const beforeText = description.substring(0, matchIndex);
    const afterText = description.substring(matchIndex + MULTIPLE_VEHICLES_TEXT.length);

    // Stop the click from bubbling to the parent (e.g. the claim card) before navigating.
    const handleMultipleVehiclesClick = (e: React.MouseEvent) => {
      e.stopPropagation();
      onMultipleVehiclesClick();
    };

    return (
      <span data-dd-privacy={maskInDatadog ? 'mask' : undefined}>
        {beforeText}
        <span
          style={{
            textDecoration: 'underline',
            cursor: 'pointer',
            color: theme.palette.primary.main,
          }}
          onClick={handleMultipleVehiclesClick}
        >
          {MULTIPLE_VEHICLES_TEXT}
          {afterText}
        </span>
      </span>
    );
  }

  return <span data-dd-privacy={maskInDatadog ? 'mask' : undefined}>{description}</span>;
}
